import React, { useState, useEffect } from 'react';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_51O9W0XJ4Gs8frIDmtfg2CVeIZ4MPJKFHVOgyHle5URFeRM19JNgkyMZAJ08CblBHjlQL1U3Uzn54TtGUs8TukQkD00g83RfLSo');

const Cagnottes = () => {
  const [cagnottes, setCagnottes] = useState([]);
  const [nom, setNom] = useState('');
  const [montant, setMontant] = useState('');
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const API_URL = 'https://api.lii.com.co:5101/api/cagnottes';

  useEffect(() => {
    fetch(API_URL, { credentials: 'include' })
      .then(async (res) => {
        console.log("📡 Réponse HTTP:", res.status);
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`❌ Erreur HTTP ${res.status}: ${errorText}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("📩 API Response:", data);
        if (Array.isArray(data)) {
          setCagnottes(data);
        } else {
          console.error("❌ L'API ne renvoie pas un tableau:", data);
        }
      })
      .catch((err) => console.error('❌ Erreur chargement cagnottes:', err));
  }, []);

  const handleAddCagnotte = () => {
    if (nom.trim() === '' || montant <= 0) {
      alert("Please provide a valid name and amount.");
      return;
    }

    const cagnotteData = { 
      name: nom, 
      targetAmount: parseFloat(montant), 
      eventId: "67b4f64dab26d348e42d98b4" 
    };

    console.log("📡 Envoi de la requête POST avec :", cagnotteData);

    fetch(API_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cagnotteData),
      credentials: 'include',
    })
      .then(async (res) => {
        console.log("📡 Réponse HTTP POST:", res.status);
        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(`❌ Erreur HTTP ${res.status}: ${errorText}`);
        }
        return res.json();
      })
      .then((data) => {
        console.log("✅ Réponse JSON reçue :", data);
        if (data.cagnotte) {
          setCagnottes([...cagnottes, data.cagnotte]);
        } else {
          console.error("❌ Erreur ajout cagnotte: Réponse inattendue", data);
        }
        setNom('');
        setMontant('');
        setIsFormVisible(false);
      })
      .catch((err) => console.error("❌ Erreur ajout cagnotte:", err));
  };

  // 🛑 Suppression instantanée d'une cagnotte
  const handleDeleteCagnotte = async (id) => {
    console.log(`🗑️ Suppression de la cagnotte ID: ${id}`);

    try {
      const response = await fetch(`${API_URL}/${id}`, { method: 'DELETE' });

      if (!response.ok) {
        throw new Error("Erreur lors de la suppression de la cagnotte");
      }

      setCagnottes(cagnottes.filter((cagnotte) => cagnotte._id !== id));
      console.log("✅ Cagnotte supprimée avec succès !");
    } catch (error) {
      console.error("❌ Erreur suppression cagnotte:", error);
    }
  };

  // 💳 Stripe - Paiement
  const handlePayment = async (cagnotteId, amount) => {
    const stripe = await stripePromise;
    try {
      console.log(`💳 Paiement de ${amount}€ pour la cagnotte ID ${cagnotteId}`);

      const response = await fetch(`${API_URL}/create-checkout-session`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cagnotteId, amount }),
        credentials: 'include',
      });

      const session = await response.json();
      if (!session.id) {
        console.error("❌ Erreur Stripe :", session);
        return;
      }

      const result = await stripe.redirectToCheckout({ sessionId: session.id });

      if (result.error) {
        console.error(result.error.message);
      }
    } catch (error) {
      console.error("❌ Erreur lors du paiement:", error);
    }
  };

  return (
    <div>
      <h2 className="text-lg font-bold mb-4">Cagnottes</h2>
      <p className="text-gray-600 mb-4">Gérez les finances de votre famille</p>

      <button onClick={() => setIsFormVisible(!isFormVisible)} className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition duration-300 mb-4">
        {isFormVisible ? 'Réduire' : 'Créer une cagnotte'}
      </button>

      {isFormVisible && (
        <div className="mb-4">
          <input type="text" value={nom} onChange={(e) => setNom(e.target.value)} className="w-full p-2 mb-2 border rounded" placeholder="Entrez un nom de cagnotte" />
          <input type="number" value={montant} onChange={(e) => setMontant(e.target.value)} className="w-full p-2 mb-2 border rounded" placeholder="Entrez le montant visé 🎯" />
          <button onClick={handleAddCagnotte} className="w-full bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition duration-300">
Créer un cagnotte          </button>
        </div>
      )}

      <div>
        {cagnottes.length === 0 ? (
          <p className="text-gray-500">Pas encore de cagnotte</p>
        ) : (
          cagnottes.map((cagnotte) => (
            <div key={cagnotte._id} className="relative p-4 bg-gray-50 border rounded shadow mb-4">
              <h3 className="font-semibold">{cagnotte.name}</h3>
              <p className="text-gray-700">Montant {cagnotte.targetAmount}€</p>

              {/* Menu de suppression */}
              <div className="absolute top-2 right-2">
                <button
                  onClick={() => setActiveMenu(activeMenu === cagnotte._id ? null : cagnotte._id)}
                  className="text-gray-400 hover:text-gray-600 focus:outline-none"
                  title="Options"
                >
                  &#x2026;
                </button>

                {activeMenu === cagnotte._id && (
                  <div className="absolute top-6 right-0 bg-white border shadow rounded z-50">
                    <ul>
                      <li
                        onClick={() => {
                          handleDeleteCagnotte(cagnotte._id);
                          setActiveMenu(null);
                        }}
                        className="px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
                      >
Supprimer la cagnotte                      </li>
                    </ul>
                  </div>
                )}
              </div>

              <button onClick={() => handlePayment(cagnotte._id, cagnotte.targetAmount)} className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700 transition duration-300">
                Contribuer
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Cagnottes;